<template>
	<Modal @close="$emit('close')" size="large">
		<div class="container">
			<div class="row">
				<div class="col-12">
					<h3>Edit {{plan.title}}</h3>
				</div>
			</div>
			<Form :plan="plan" @close="$emit('close')"/>
		</div>
	</Modal>
</template>

<script>
import Modal from './../Modal.vue'
import Form from './Form.vue'

export default {
	components: {
		Modal,
		Form
	},
	props: [
		'plan'
	]
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/Plans/Edit.vue